<template>
    <div :class="[pageType==='config'?'p10 bg-wrap-color bg-white':'bg-white']">
        <RoleConfig @togglePage="toggle" v-if="pageType==='config'"/>
        <BatchAdd :list="roleList" @togglePage="toggle" v-else-if="pageType==='batchAdd'"/>
        <BatchRemove :list="roleList" @togglePage="toggle" v-else-if="pageType==='batchRemove'"/>
        <RoleList @togglePage="toggle" @batch="toBatchPage" v-else/>
    </div>
</template>

<script>
    import RoleConfig from './page/roleConfig1';
    import BatchAdd from './page/batchAdd';
    import BatchRemove from './page/batchRemove';
    import RoleList from './page/roleList';

    export default {
        name: "RoleManagement",
        components: {
            RoleList,
            RoleConfig,
            BatchAdd,
            BatchRemove,
        },
        data() {
            return {
                pageType: 'list',
                roleList:[],
            }
        },
        created() {

            let query = this.$route.query;
            if (query) {
                if(query.action === 'config'){
                    this.pageType = 'config';
                    this.roleList = [];
                }else if(query.action === 'batchAdd'){
                    this.pageType = 'batchAdd';
                }else if(query.action === 'batchRemove'){
                    this.pageType = 'batchRemove';
                }
            }
        },
        methods: {
            toggle(type) {
                if(type){
                    if(type=='list'||type=='listPage'){
                        this.pageType = 'list';
                    }else{
                        console.log('toggle',type);
                    }
                }else{
                    this.pageType = this.pageType === 'config' ? 'list' : 'config';
                }
            },
            toBatchPage(page,rowList){
                this.pageType = page;
                this.roleList = rowList||[];
            },
        }
    }
</script>

<style lang="scss" scoped>
    .p10{
        padding: 10px;
    }
    .bg-wrap-color{
        background-color: #F1F4F9;
    }
</style>
